import React from 'react';

function HealthAssessment() {
    return (
        <div>
            <h1>Health Assessment</h1>
            <p>Conduct health assessments here.</p>
        </div>
    );
}

export default HealthAssessment;
